const CURRENT_ESTABLISHMENT_KEY = 'current_establishment';

/**
 * Get the current establishment from the session
 * @returns The current establishment
 */
export function getCurrentEstablishment() {
  const session = localStorage.getItem(CURRENT_ESTABLISHMENT_KEY);
  if (!session) {
    return null;
  }
  return JSON.parse(session);
}

/**
 * Set the current establishment in the session
 * @param establishment The establishment to set
 */
export function setCurrentEstablishment(establishment: any) {
  localStorage.setItem(CURRENT_ESTABLISHMENT_KEY, JSON.stringify(establishment));
}

/**
 * Remove the current establishment from the session
 */
export function removeCurrentEstablishment() {
  localStorage.removeItem(CURRENT_ESTABLISHMENT_KEY);
}
